import { useEffect, useState } from "react";

import jBox from "jbox";
import $ from "jquery";

const ModalOtpSuccess = ({ open = false, onClose = () => {} }) => {
  const [modal, setModal] = useState(null);

  const openModal = () => {
    modal.open();
  };

  const closeModal = () => {
    modal.close();
    onClose();
  };

  const listenerCloseModal = () => {
    const btnCloseModal = document.getElementById("btnCloseModal");
    btnCloseModal.addEventListener("click", () => {
      closeModal();
    });
  };

  /* First event render */
  useEffect(() => {
    const initModal = new jBox("Modal", {
      closeButton: false,
      closeOnClick: false,
      minWidth: 325,
      maxWidth: 375,
      content: $("#ModalConfirm"),
    });
    setModal(initModal);

    return () => {
      initModal.destroy();
    };
  }, []);
  /* End First event render */

  useEffect(() => {
    // console.log("modalQrCode useEffect2!! >>", modalQrCode, open);

    if (modal && open) {
      openModal();
      listenerCloseModal();
      // setTimeout(() => listenerCloseModal(), 100)
    }
  }, [modal, open]);

  return (
    <div className="bModal bCard" id="ModalConfirm">
      <div className="bInner">
        <p>ยืนยันตัวตนสำเร็จ</p>
        <div className="modlaBtn" id="btnCloseModal">
          <a className="confirmBtn btnCloseModal">ปิด</a>
        </div>
      </div>
    </div>
  );
};

export default ModalOtpSuccess;
